
import { useState } from 'react';
import PlanFeature from './PlanFeature';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PlanFeatureType {
  feature: string;
  description?: string;
  included: boolean;
}

interface PlanCardProps {
  name: string;
  price: number;
  period: string;
  description: string;
  features: PlanFeatureType[];
  popular?: boolean;
  whatsappIncluded: number;
  whatsappPrice?: number;
  users: number;
  negotiationsIncluded: number;
  extraNegotiationsPrice?: number;
  setupFee: number;
  onSelect: (plan: string) => void;
}

export default function PlanCard({
  name,
  price,
  period,
  description,
  features,
  popular = false,
  whatsappIncluded,
  whatsappPrice = 0,
  users,
  negotiationsIncluded,
  extraNegotiationsPrice = 0,
  setupFee,
  onSelect,
}: PlanCardProps) {
  const formatPrice = (value: number) => value.toLocaleString('pt-BR');

  return (
    <div className={`plan-card ${popular ? 'popular' : ''}`}>
      {popular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brand-roxo text-white font-bold py-1 px-3 rounded-full text-xs uppercase tracking-wider">
          Recomendado
        </div>
      )}
      <h3 className="font-display text-xl md:text-2xl font-bold text-brand-azul mb-2">{name}</h3>
      <p className="text-brand-azul/70 mb-4 min-h-[50px]">{description}</p>
      
      <div className="price-tag mb-4">
        R$ {formatPrice(price)} <small>/{period}</small>
      </div>

      <div className="mb-2 text-sm text-brand-azul/80">
        <span className="font-semibold">Implantação:</span> Sob consulta
      </div>
      
      <div className="mb-4 text-sm">
        <div className="mb-2">
          <span className="font-semibold">{whatsappIncluded}</span> contas WhatsApp inclusas
          {whatsappPrice > 0 && (
            <span className="block text-brand-azul/60">+R$ {formatPrice(whatsappPrice)}/conta adicional</span>
          )}
        </div>
        <div>
          <span className="font-semibold">{users} usuários</span>
          <span className="mx-1">•</span>
          <span className="font-semibold">{negotiationsIncluded}</span> negociações/mês
          {extraNegotiationsPrice > 0 && (
            <span className="block text-brand-azul/60">+R$ {formatPrice(extraNegotiationsPrice)}/100 adicionais</span>
          )}
        </div>
      </div>

      <div className="feature-list my-6 flex-grow">
        {features.map((feat, index) => (
          <PlanFeature
            key={index}
            feature={feat.feature}
            description={feat.description}
            included={feat.included}
          />
        ))}
      </div>
      
      <Button
        className={`w-full ${popular
          ? 'bg-brand-roxo hover:bg-brand-roxo/90 text-white'
          : 'bg-brand-azul hover:bg-brand-azul/90 text-white'}
          py-2.5 rounded-full font-semibold flex items-center justify-center gap-2 mt-auto`}
        onClick={() => onSelect(name)}
      >
        Selecionar plano <ArrowRight size={16} />
      </Button>
    </div>
  );
}
